import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=52aadb29&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aadb29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52aadb29')) {
      api.createRecord('52aadb29', component.options)
    } else {
      api.reload('52aadb29', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=52aadb29&scoped=true&", function () {
      api.rerender('52aadb29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fPX6oW4tXsFX/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports